import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar autenticación a todas las peticiones
api.interceptors.request.use((config) => {
  const usuarioGuardado = sessionStorage.getItem('usuario');
  if (usuarioGuardado) {
    try {
      const usuario = JSON.parse(usuarioGuardado);
      // Agregar DNI como header
      if (usuario.dni) {
        config.headers['x-user-dni'] = usuario.dni;
      }
      // Agregar tipo de usuario
      if (usuario.tipo_usuario) {
        config.headers['x-user-type'] = usuario.tipo_usuario;
      }
    } catch (error) {
      console.error('Error parsing usuario from sessionStorage:', error);
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const validarUsuario = (dni) => api.post('/auth/validar', { dni });
export const verificarPedidoExistente = (dni) => api.get(`/auth/pedido/${dni}`);

// Platos
export const getPlatos = () => api.get('/menu/platos');
export const crearPlato = (data) => api.post('/admin/platos', data);
export const actualizarPlato = (id, data) => api.put(`/admin/platos/${id}`, data);
export const eliminarPlato = (id) => api.delete(`/admin/platos/${id}`);

// Categorías
export const getCategorias = () => api.get('/categorias');
export const getCategoria = (id) => api.get(`/categorias/${id}`);
export const crearCategoria = (data) => api.post('/categorias', data);
export const actualizarCategoria = (id, data) => api.put(`/categorias/${id}`, data);
export const eliminarCategoria = (id) => api.delete(`/categorias/${id}`);
export const reordenarCategorias = (data) => api.post('/categorias/reordenar', data);

// Menú
export const getMenuPorFecha = (fecha) => api.get(`/menu/fecha/${fecha}`);
export const getMenuRango = (fechaInicio, fechaFin, sedeId, tipoComida = 'almuerzo') => {
  let url = `/admin/menu/rango?fechaInicio=${fechaInicio}&fechaFin=${fechaFin}`;
  if (sedeId) url += `&sede_id=${sedeId}`;
  if (tipoComida) url += `&tipo_comida=${tipoComida}`;
  return api.get(url);
};
export const getMenuDiaSiguiente = (sedeId) => api.get(`/menu/siguiente?sedeId=${sedeId}`);
export const cargarMenuDia = (data) => api.post('/admin/menu/dia', data);
export const cargarMenuMensual = (data) => api.post('/admin/menu/mensual', data);
export const actualizarDisponibilidadMenu = (fecha, platoId, data) =>
  api.put(`/admin/menu/${fecha}/${platoId}/disponibilidad`, data);

// Pedidos
export const getPedidos = (params) => api.get('/admin/pedidos', { params });
export const getEstadisticas = (fecha) => api.get(`/pedidos/estadisticas/${fecha}`);
export const exportarReporte = (fechaInicio, fechaFin) =>
  api.get('/admin/pedidos/reporte', { params: { fechaInicio, fechaFin } });
export const crearPedido = (data) => api.post('/pedidos', data);
export const crearPedidosMultiples = (data) => api.post('/pedidos/multiples', data);
export const getPedidosUsuario = (dni) => api.get(`/pedidos/usuario/${dni}`);
export const cancelarPedido = (id, dni) => api.put(`/pedidos/${id}/cancelar`, { dni });
export const eliminarPedido = (id) => api.delete(`/pedidos/${id}`);

// Usuarios
export const getUsuarios = (params) => api.get('/usuarios', { params });
export const crearUsuario = (data) => api.post('/admin/usuarios', data);
export const actualizarUsuario = (id, data) => api.put(`/usuarios/${id}`, data);
export const eliminarUsuario = (id) => api.delete(`/usuarios/${id}`);

// Configuración (requiere super_admin)
export const getConfiguracion = () =>
  api.get('/admin/configuracion');
export const actualizarConfiguracion = (data) =>
  api.put('/admin/configuracion', data);

// Configuración pública (para usuarios autenticados) - solo claves seguras usadas en UI
export const getPublicConfiguracion = () => api.get('/admin/configuracion/public');

// Sedes
export const getSedes = () => api.get('/sedes');
export const getSedesActivas = () => api.get('/sedes/activas');
export const getSedeById = (id) => api.get(`/sedes/${id}`);
export const getSedesAdmin = (usuarioId) => api.get(`/sedes/admin/${usuarioId}`);
export const crearSede = (data) => api.post('/sedes', data);
export const actualizarSede = (id, data) => api.put(`/sedes/${id}`, data);
export const eliminarSede = (id) => api.delete(`/sedes/${id}`);
export const asignarSedesAdmin = (usuarioId, sedeIds) =>
  api.post(`/sedes/admin/${usuarioId}/asignar`, { sedeIds });
export const getEstadisticasSede = (id) => api.get(`/sedes/${id}/estadisticas`);

// Sectores
export const getSectores = (params) => api.get('/sectores', { params });
export const getSectoresActivos = (sedeId) => api.get(`/sectores/sede/${sedeId}/activos`);
export const getSectorById = (id) => api.get(`/sectores/${id}`);
export const crearSector = (data) => api.post('/sectores', data);
export const crearSectoresMultiples = (data) => api.post('/sectores/multiples', data);
export const actualizarSector = (id, data) => api.put(`/sectores/${id}`, data);
export const eliminarSector = (id) => api.delete(`/sectores/${id}`);
export const getEstadisticasSector = (id) => api.get(`/sectores/${id}/estadisticas`);

export default api;
